/**
 * Telegram WebApp provider
 * Initializes Telegram SDK and applies theme
 */
import { type ReactNode, useEffect } from 'react';
import { initTelegramWebApp, getTelegramTheme } from '@/shared/utils/telegram';

interface TelegramProviderProps {
  children: ReactNode;
}

export function TelegramProvider({ children }: TelegramProviderProps) {
  useEffect(() => {
    // Initialize Telegram WebApp
    initTelegramWebApp();

    // Apply theme colors
    const { colors } = getTelegramTheme();

    if (colors && Object.keys(colors).length > 0) {
      const root = document.documentElement;

      if (colors.bg_color) {
        root.style.setProperty('--tg-theme-bg-color', colors.bg_color);
      }
      if (colors.text_color) {
        root.style.setProperty('--tg-theme-text-color', colors.text_color);
      }
      if (colors.hint_color) {
        root.style.setProperty('--tg-theme-hint-color', colors.hint_color);
      }
      if (colors.link_color) {
        root.style.setProperty('--tg-theme-link-color', colors.link_color);
      }
      if (colors.button_color) {
        root.style.setProperty('--tg-theme-button-color', colors.button_color);
      }
      if (colors.button_text_color) {
        root.style.setProperty('--tg-theme-button-text-color', colors.button_text_color);
      }
      if (colors.secondary_bg_color) {
        root.style.setProperty('--tg-theme-secondary-bg-color', colors.secondary_bg_color);
      }
    }
  }, []);

  return <>{children}</>;
}
